const heroOptions = {
   slidesToShow: 1,
   slidesToScroll: 1,
   autoplay: true,
   mobileFirst: true,
   dots: true,
   prevArrow: '<i class="fas fa-chevron-circle-left"></i>',
   nextArrow: '<i class="fas fa-chevron-circle-right"></i>',
   speed: 1000,
   autoplaySpeed: 3000,
}

$('.jsHero').each(function (index) {
   $(this).slick(heroOptions);
});



const catOptions = {
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   prevArrow: '<i class="fas fa-chevron-circle-left"></i>',
   nextArrow: '<i class="fas fa-chevron-circle-right"></i>',
   responsive: [{
         breakpoint: 767,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true
         }
      },
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true
         }
      }
   ]
}

if (window.innerWidth < 1200) {
   $('#textAdvert').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      dots: false,
      prevArrow: '',
      nextArrow: '',
      speed: 1000,
      autoplaySpeed: 3000
   });

}


$('.jsCatSlider').each(function (index) {
   $(this).slick(catOptions);
});

$('#brandSlider').slick({
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 2,
   slidesToScroll: 1,
   autoplay: true,
   prevArrow: '',
   nextArrow: '',
   responsive: [{
         breakpoint: 767,
         settings: {
            slidesToShow: 4,
            slidesToScroll: 1
         }
      },
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 7,
            slidesToScroll: 1
         }
      }
   ]
});
function prodSlider() {
   const navImg = document.querySelectorAll('.jsNavImg');

   $('#mainImage').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '#imageNav'
   });
   $('#imageNav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '#mainImage',
      prevArrow: "<i class='far fa-chevron-left'></i>",
      nextArrow: "<i class='far fa-chevron-right'></i>",
      dots: false,
   });
   
   if (navImg.length > 0) {
      const slickNav = document.querySelector('#imageNav .slick-track');
      navImg.length > 4 ? true : slickNav.classList.add('disable-scroll');
   }
}
prodSlider();
window.addEventListener('reset', prodSlider);
